import BaseConfiguratorService from "@configuratorware/configurator-frontendgui/App/Services/ConfiguratorService";
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration";
import {fetchOptions, getComponentFilters} from "../Custom/App/Shared/Actions";
import { get } from "lodash";

class ConfiguratorService extends BaseConfiguratorService {
  loadInitialConfiguration() {
    const params: any = {};
    const basePath = getConf("routingBasePath", "/");
    const itemRegex = new RegExp(`${basePath}(code|identifier):([^/]+)`);
    const results = itemRegex.exec(location.pathname);
    if (results) {
      params[results[1]] = results[2];
    }
    if (params.identifier || params.code) {
      super.loadInitialConfiguration();
    } else {
      // return console.log("//== we have a group");
    }
  }

  async loadOptions(itemIdentifier, optionClassificationIdentifier, configuration) {
    const filteredOptionClassification = get(Services.store.state, 'configurator.filteredComponentIdentifier');
    // reload filters if component changed
    if (filteredOptionClassification !== optionClassificationIdentifier) {
      await Services.store.dispatch(getComponentFilters(itemIdentifier, optionClassificationIdentifier));
    }
    const optionFilterIdentifier = get(Services.store.state, 'configurator.activeComponentFilter');
    if (optionFilterIdentifier) {
      Services.store.dispatch(fetchOptions(itemIdentifier, optionClassificationIdentifier, configuration, optionFilterIdentifier));
    } else {
      super.loadOptions(itemIdentifier, optionClassificationIdentifier, configuration);
    }
  }
}

export default ConfiguratorService;
